import React from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Box } from '../UI-CHAKRA/Box';
import { Flex } from '../UI-CHAKRA/Flex';
import { Text } from '../UI-CHAKRA/Text';
import { Button } from '../UI-CHAKRA/Button';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/icons/info.svg';
import { TrackerEventService } from '../../containers/prescription/trackerEventService';
import { useIsMobile } from '../../helpers/useIsMobile';
import { getPspBenefit, PSPBenefit } from '../../interfaces/medicine';

interface PspModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  prescription?: {
    idPrescricao: number;
    CodigoValidacao?: string;
    Paciente?: {
      idPaciente: number;
    };
    Prescritor?: {
      idPrescritor: number;
    };
    idPrescritor?: number;
  };
  prescriberConfiguration?: {
    idParceiro?: number;
  };
  medicineData?: {
    IdMedicamento: number;
    ListaEANS?: string[];
    EANs?: string[];
    Beneficios?: PSPBenefit[];
  };
}

const PspModal: React.FC<PspModalProps> = ({ isOpen, onClose, onConfirm, prescription, prescriberConfiguration, medicineData }) => {
  const isMobile = useIsMobile();
  const listaEans = medicineData?.EANs ?? medicineData?.ListaEANS ?? [];
  const nomeDoPrograma = getPspBenefit(medicineData?.Beneficios)?.Nome;

  const handleClose = async () => {
    if (prescription && medicineData) {
      await TrackerEventService.track(prescription.idPrescricao, 'backoffice_campaign_psp_cta_continuar_click', {
        flow: 'assinar prescrição',
        idPrescricao: prescription.idPrescricao,
        codigoValidacao: prescription.CodigoValidacao,
        idParceiro: prescriberConfiguration?.idParceiro,
        idMedico: prescription.Prescritor?.idPrescritor || prescription.idPrescritor,
        idPaciente: prescription.Paciente?.idPaciente,
        idMedicamento: medicineData.IdMedicamento,
        listaEans,
        nomeDoPrograma,
        ambiente: process.env.REACT_APP_ENVIRONMENT || 'staging',
        isMobile: isMobile,
        interessePreCadastro: false,
      });
    }
    onClose();
  };

  const handleConfirm = async () => {
    if (prescription && medicineData) {
      await TrackerEventService.track(prescription.idPrescricao, 'backoffice_campaign_psp_cta_continuar_click', {
        flow: 'assinar prescrição',
        idPrescricao: prescription.idPrescricao,
        codigoValidacao: prescription.CodigoValidacao,
        idParceiro: prescriberConfiguration?.idParceiro,
        idMedico: prescription.Prescritor?.idPrescritor || prescription.idPrescritor,
        idPaciente: prescription.Paciente?.idPaciente,
        idMedicamento: medicineData.IdMedicamento,
        listaEans,
        nomeDoPrograma,
        ambiente: process.env.REACT_APP_ENVIRONMENT || 'staging',
        isMobile: isMobile,
        interessePreCadastro: true,
      });
    }
    onConfirm();
  };
  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.5)" backdropFilter="blur(2px)" />
      <ModalContent
        maxW={{ base: '90%', md: '500px' }}
        borderRadius={'20px'}
        padding={'0px'}
        boxShadow={'0px 0px 20px 7px rgba(0,0,0,0.25)'}
      >
        <Box padding={'24px'} position={'relative'}>
          <Flex position={'absolute'} top={'24px'} left={'24px'} alignItems={'center'} justifyContent={'center'}>
            <Box
              width={'32px'}
              height={'32px'}
              borderRadius={'50%'}
              backgroundColor={'primary.main'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <InfoIcon width={'20px'} height={'20px'} fill="#FFFFFF" />
            </Box>
          </Flex>
          <Box position={'absolute'} top={'24px'} right={'24px'}>
            <CloseIcon onClick={handleClose} cursor={'pointer'} />
          </Box>

          <Box mb={'16px'} mt={'56px'}>
            <Text fontSize={'20px'} fontWeight={700} color={'#1E252B'} lineHeight={'28px'}>
              Apoio disponível para o paciente
            </Text>
          </Box>

          <Text fontSize={'14px'} color={'#545C62'} mb={'24px'} lineHeight={'20px'}>
            Esta receita possui medicamento elegível para um Programa de Suporte ao Paciente. Gostaria de iniciar o
            pré-cadastro para oferecer este serviço de apoio gratuito ao paciente?
          </Text>

          <Flex gap={'12px'} justifyContent={'flex-end'}>
            <Button
              onClick={handleClose}
              padding="10px 20px"
              backgroundColor={'#FFF'}
              borderWidth={'2px'}
              borderColor={'primary.main'}
              borderStyle={'solid'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'primary.main'}>
                Não, obrigado
              </Text>
            </Button>
            <Button
              onClick={handleConfirm}
              padding="10px 20px"
              backgroundColor={'primary.main'}
              borderRadius={'20px'}
              _hover={{ backgroundColor: '#6B409C' }}
            >
              <Text fontSize={'14px'} color={'#FFF'}>
                Sim, iniciar pré-cadastro
              </Text>
            </Button>
          </Flex>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PspModal;
